// extracted by mini-css-extract-plugin
module.exports = {"decimalPart":"FinanceAmountFormat_decimalPart__AKgJ_"};